import styled from "styled-components";
import { Grid } from "@mui/material";

export const FormSection = styled(Grid)`
  && {
    padding: 16px 0;
  }
`;
